import {Box, Button, Flex, Image, Text} from "@mantine/core";
import {IconMinus, IconPlus, IconTrash} from "@tabler/icons-react";
import ProductPlaceholderImage from '../../../../../assets/images/product_placeholder.png';

const _CartItem3 = ({component}) => {
    return (
        <Box
            mx={component?.customize_styles?.general_decoration?.margin_x}
            my={component?.customize_styles?.general_decoration?.margin_y}
            px={component?.customize_styles?.general_decoration?.padding_x}
            py={component?.customize_styles?.general_decoration?.padding_y}
            bg={component?.customize_styles?.general_decoration?.background_color}
            style={{
                boxShadow: `${component?.customize_styles?.general_decoration?.shadow_offset_x}px ${component?.customize_styles?.general_decoration?.shadow_offset_y}px ${component?.customize_styles?.general_decoration?.shadow_blur_radius}px ${component?.customize_styles?.general_decoration?.shadow_blur_radius}px #00000014`,
                borderRadius: `${component?.customize_styles?.general_decoration?.border_radius}px`,
                border: `${component?.customize_styles?.general_decoration?.border_width}px solid ${component?.customize_styles?.general_decoration?.border_color}`,
            }}
        >
            <Box
                mx={component?.customize_styles?.box_decoration?.margin_x}
                my={component?.customize_styles?.box_decoration?.margin_y}
                px={component?.customize_styles?.box_decoration?.padding_x}
                py={component?.customize_styles?.box_decoration?.padding_y}
                bg={component?.customize_styles?.box_decoration?.background_color}
                style={{
                    boxShadow: `${component?.customize_styles?.box_decoration?.shadow_offset_x}px -${component?.customize_styles?.box_decoration?.shadow_offset_y}px ${component?.customize_styles?.box_decoration?.shadow_blur_radius}px ${component?.customize_styles?.box_decoration?.shadow_blur_radius}px #00000014`,
                    borderRadius: `${component?.customize_styles?.box_decoration?.border_radius}px`,
                    border: `${component?.customize_styles?.box_decoration?.border_width}px solid ${component?.customize_styles?.box_decoration?.border_color}`,
                }}
            >
                <Flex align="center" gap={20}>
                    <Box
                        w={component?.customize_styles?.image_decoration?.width}
                        h={component?.customize_styles?.image_decoration?.height}
                        // bg={component?.customize_styles?.image_decoration?.color}
                        style={{
                            borderRadius: `${component?.customize_styles?.image_decoration?.radius}px`
                        }}
                    >
                        <Image
                            style={{ width: "100%", height: "100%" }}
                            src=""
                            fallbackSrc={ProductPlaceholderImage}
                            alt=""
                            radius={component?.customize_styles?.image_decoration?.radius}
                        />
                    </Box>

                    <Box>
                        <Text
                            c={component?.customize_styles?.name_text_decoration?.color}
                            fw={component?.customize_styles?.name_text_decoration?.font_weight}
                            fz={component?.customize_styles?.name_text_decoration?.font_size}
                            fs={component?.customize_styles?.name_text_decoration?.font_style}
                            translate="yes"
                            lineClamp={1}
                        >
                            Product Name
                        </Text>
                        <Text
                            fw={700}
                            c={component?.customize_styles?.product_price_text_decoration?.color}
                        >
                            $ 0.00
                        </Text>
                    </Box>
                </Flex>

                <Flex mt={32} justify="space-between" align="center">
                    <Flex gap={10} justify="center" align="center">
                        <Flex justify="center" align="center" bg="#000" c="#fff" p={2} style={{ borderRadius: "5px", boxShadow: "4px 4px 6px 3px #cdcdcd" }}><IconMinus size={22}></IconMinus></Flex>
                        <Text>1</Text>
                        <Flex justify="center" align="center" bg="#000" c="#fff" p={2} style={{ borderRadius: "5px", boxShadow: "4px 4px 6px 3px #cdcdcd" }}><IconPlus size={22}></IconPlus></Flex>
                    </Flex>

                    <Flex align="center">
                        <Text c="#838383" mt={5}>
                            <IconTrash></IconTrash>
                        </Text>
                        <Button bg="transparent" fw={500} pl={0} ml={5} pr={0} c="#838383">Remove</Button>
                    </Flex>
                </Flex>
            </Box>
        </Box>
    )
}
export default _CartItem3;